import { RedirctUrlService } from './../../services/redirct-url.service';
import { CustomerSupportService } from './../../services/customer-support/customer-support.service';
import { Component, Inject, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import 'rxjs/add/operator/map';
import { Observable, Subscription } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FlashMessageService } from '../../services/flash-message.service';
import { TokenStorageService } from 'src/app/core/security/token-storage-service';
import { Storage } from './../../../core/services/storage.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';

@Component({
  selector: 'hc-customer-support',
  templateUrl: './customer-support.component.html',
  styleUrls: ['./customer-support.component.scss']
})
export class CustomerSupportComponent implements OnInit {

  constructor(private modal: ModalService,
    private _customerSupportSvc: CustomerSupportService,
    private _tokenService: TokenStorageService,
    private _redirectSvc: RedirctUrlService,
    private storage: Storage,
    public currentUserService: CurrentUserService,
    private _flashMessageSvc: FlashMessageService) { }

  public userOptions: any = [];
  public userType: string = 'CUSTOMER';
  public targetUser: string;
  public targetUserSelected: boolean;
  subscription: Subscription;
  impersonateUserName: any;

  public isSupportUser: boolean = false;

  async ngOnInit() {
    this._initSearch();
    this._setImpersonatorUserName();
    this.isSupportUser = await this._tokenService.isSupportUser()
  }

  close() {
    this.modal.close();
  }

  /**
   * Impersonate target user
   */
  public async impersonateUser() {
    try {
      await this._customerSupportSvc.imporsonateUser(this.targetUser, this.userType);
      this._redirectSvc.navigateToBaseUrl();
    } catch (err) {
      this._flashMessageSvc.updateMessage("Failed to impersonate user.");
    }
  }

  /**
   * Set targetUserSelected flag if user selects from DropDown
   */
  public userSelected() {
    this.targetUserSelected = true;
  }

  /**
   * Reset target user when userType CUSTOMER/SUPPLIER changed
   */
  public userTargetChanged() {
    this.targetUser = null;
    this.targetUserSelected = false;
  }

  /**
   * revert back to admin user
   */
  async revertToAdminUser() {
    try {
      await this._customerSupportSvc.revertToAdminUser();
    } catch (err) {
      this._flashMessageSvc.updateMessage("Failed to revert back as admin user.");
    }
  }

  private async _setImpersonatorUserName() {
    try {
      const impersonator = JSON.parse(await this.storage.getItem('impersonator'));
      this.impersonateUserName = JSON.parse(impersonator.user).username;
    } catch (err) {
      this.impersonateUserName = `${this.currentUserService.user.organizationType} user`;
    }
  }

  /**
   * Initialize target username search
   */
  private _initSearch() {
    Observable.fromEvent(document.getElementById('targetUsername'), 'input').pipe(
      map((element: KeyboardEvent) => {
        return element['target']['value'];
      }),
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(async (searchText: any) => {
      this.targetUserSelected = false;
      if (!searchText || !searchText.trim().length || searchText.trim().length < 3) {
        this.userOptions = []
      } else {
        this.userOptions = await this._customerSupportSvc.searchUsers(searchText, this.userType);
      }
    });
  }
}
